import snakeCase from 'lodash/snakeCase'

//A simple snakeCase function that mainly converts camelCase string to snakeCase.
export function toSnakeCase(str: string): string {
  return str.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`)
}

//Extensive snakeCase function that supports many edge cases and handles various text formats
export function toSnakeCaseLodash(str: string): string {
  return snakeCase(str)
}

type SnakeCaseValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | Date
  | SnakeCaseValue[]
  | { [key: string]: SnakeCaseValue }

type SnakeCaseKeys<T> = T extends null | undefined
  ? T
  : T extends (infer U)[]
  ? SnakeCaseKeys<U>[]
  : T extends object
  ? Record<string, any>
  : T

export function snakeCaseKeys<T extends SnakeCaseValue>(obj: T): SnakeCaseKeys<T> {
  if (obj === null || obj === undefined) {
    return obj as SnakeCaseKeys<T>
  }

  if (Array.isArray(obj)) {
    return obj.map((item) => snakeCaseKeys(item)) as SnakeCaseKeys<T>
  }

  if (typeof obj === 'object' && obj.constructor === Object) {
    return Object.keys(obj).reduce((result, key) => {
      const snakeCaseKey = toSnakeCase(key)
      result[snakeCaseKey] = snakeCaseKeys((obj as Record<string, SnakeCaseValue>)[key])
      return result
    }, {} as Record<string, SnakeCaseValue>) as SnakeCaseKeys<T>
  }

  return obj as SnakeCaseKeys<T>
}
